// CSS import
import './style.css'

// 1. Import the Agents SDK library
import * as sdk from "@d-id/client-sdk"

// Import speech recognition utilities
import speechRecognitionUtils from './webSpeechAPI.js';

// Define agentId and auth
const agentId = "agt_1a1P_pcw";
const auth = { type: 'key', clientKey: "Z29vZ2xlLW9hdXRoMnwxMTQ1NDMxMzI3OTUwMTQ5MTY2Nzc6czBKZ0V1X25Yek9oWnpyQUhYenY0" };

let agentManager; // Declare agentManager in a higher scope

const API_ENDPOINT = window.location.origin;

const customFetch = (url, options = {}) => {
  return fetch(url, {
    ...options,
    mode: 'no-cors',
    credentials: 'include',
  }).then(response => {
    if (!response.ok && response.type !== 'opaque') {
      throw new Error('Network response was not ok');
    }
    return response;
  });
};

document.addEventListener('DOMContentLoaded', async () => {
  // HTML Variables declaration
  const videoElement = document.querySelector("#videoElement");
  const textArea = document.querySelector("#textArea");
  const langSelect = document.querySelector("#langSelect");
  const speechButton = document.querySelector("#speechButton");
  const answers = document.querySelector("#answers");
  const connectionLabel = document.querySelector("#connectionLabel");
  const speakButton = document.querySelector('#speakButton');
  const reconnectButton = document.querySelector('#reconnectButton');
  let srcObject;

  // 4. Define the SDK callbacks functions in this object
  const callbacks = {
    onSrcObjectReady(value) {
      console.log("onSrcObjectReady():", value)
      videoElement.srcObject = value
      srcObject = value
      return srcObject
    },

    onConnectionStateChange(state) {
      console.log("onConnectionStateChange(): ", state)

      if (state == "connecting") {
        connectionLabel.innerHTML = "Connecting.."
        document.querySelector("#container").style.display = "flex"
        document.querySelector("#hidden").style.display = "none"
      }
      else if (state == "connected") {
        speakButton.removeAttribute("disabled")
        langSelect.removeAttribute("disabled")
        speechButton.removeAttribute("disabled")
        connectionLabel.innerHTML = "Online"
      }
      else if (state == "disconnected" || state == "closed") {
        document.querySelector("#hidden_h2").innerHTML = `${agentManager.agent.preview_name} Disconnected`
        document.querySelector("#hidden").style.display = "block"
        document.querySelector("#container").style.display = "none"
        speakButton.setAttribute("disabled", true)
        langSelect.setAttribute("disabled", true)
        speechButton.setAttribute("disabled", true)
        connectionLabel.innerHTML = ""
      }
    },

    onVideoStateChange(state) {
      console.log("onVideoStateChange(): ", state)
      if (state == "STOP") {
        videoElement.muted = false
        videoElement.srcObject = undefined
        if (agentManager && agentManager.agent && agentManager.agent.presenter) {
          videoElement.src = agentManager.agent.presenter.idle_video
        }
      }
      else {
        videoElement.muted = false
        videoElement.src = ""
        videoElement.srcObject = srcObject
        connectionLabel.innerHTML = "Online"
      }
    },

    onNewMessage(messages, type) {
      console.log("onNewMessage():", messages, type)
      // We only want to process messages from our custom API
      if (type === 'custom') {
        let lastIndex = messages.length - 1
        let msg = messages[lastIndex]
        answers.innerHTML += `${timeDisplay()} - [${msg.role}] : ${msg.content}  <br>`
        answers.scrollTop = answers.scrollHeight
      }
    },

    onError(error, errorData) {
      connectionLabel.innerHTML = `<span style="color:red">Something went wrong :(</span>`
      console.log("Error:", error, "Error Data", errorData)
    }
  }

  // 5. Define the Stream options object (Optional)
  const streamOptions = { compatibilityMode: "auto", streamWarmup: true, fluent: true };

  async function speak(input) {
    if (input !== "" && input.length > 2) {
      try {
        // Add user message to the chat display
        answers.innerHTML += `${timeDisplay()} - [user] : ${input}  <br>`;
        answers.scrollTop = answers.scrollHeight;

        const response = await fetch(`${API_ENDPOINT}/api/claude`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ input: input })
        });
        const data = await response.json();
        
        if (agentManager) {
          // Call onNewMessage with our custom response
          callbacks.onNewMessage([{ role: 'assistant', content: data.response }], 'custom');

          let speakResult = await agentManager.speak(
            {
              type: "text",
              input: data.response
            }
          );
          console.log(`agentManager.speak("${data.response}")`);
          connectionLabel.innerHTML = "Streaming..";
          textArea.value = ""; // Clear the input after sending
        } else {
          console.error("Agent manager not initialized");
          connectionLabel.innerHTML = "Error: Agent not ready";
        }
      } catch (error) {
        console.error('Error:', error);
        connectionLabel.innerHTML = "Error occurred";
      }
    }
  }

  function rate(messageID, score) {
    if (agentManager) {
      let rate = agentManager.rate(messageID, score)
      console.log(`Message ID: ${messageID} Rated:${score}\n`, "Result", rate)
    } else {
      console.error("Agent manager not initialized");
    }
  }

  function reconnect() {
    console.log("Reconnect clicked")
    if (agentManager) {
      let reconnect = agentManager.reconnect()
      console.log("agentManager.reconnect()", reconnect)
    } else {
      console.error("Agent manager not initialized");
      connectionLabel.innerHTML = "Error: Cannot reconnect";
    }
  }

  function disconnect() {
    if (agentManager) {
      let disconnect = agentManager.disconnect()
      console.log("agentManager.disconnect()", disconnect)
    } else {
      console.error("Agent manager not initialized");
    }
  }

  function timeDisplay() {
    const currentTime = new Date();
    const hours = currentTime.getHours().toString().padStart(2, '0');
    const minutes = currentTime.getMinutes().toString().padStart(2, '0');
    const seconds = currentTime.getSeconds().toString().padStart(2, '0');
    const formattedTime = `${hours}:${minutes}:${seconds}`;
    return formattedTime;
  }

  async function initializeAgentManager() {
    try {
      // Create a custom SDK configuration object
      const sdkConfig = {
        apiUrl: `${API_ENDPOINT}/d-id-api`,  // Use our proxy URL for all requests
        iceServers: [
          {
            urls: 'stun:stun.l.google.com:19302'
          }
        ],
        fetch: customFetch  // Use our custom fetch function
      };

      // Create the 'agentManager' instance with the updated configuration
      agentManager = await sdk.createAgentManager(agentId, { auth, callbacks, streamOptions, sdkConfig });

      console.log("sdk.createAgentManager()", agentManager);

      if (!agentManager || !agentManager.agent) {
        throw new Error("Agent manager or agent not initialized properly");
      }

      // Displaying the Agent's name in the HTML Header
      const previewNameElement = document.querySelector("#previewName");
      if (previewNameElement) {
        previewNameElement.innerHTML = agentManager.agent.preview_name || "Agent Name Not Available";
      }

      // Connect to the agent
      console.log("agentManager.connect()");
      await agentManager.connect();

      return agentManager;
    } catch (error) {
      console.error("Error initializing agent manager:", error);
      if (connectionLabel) {
        connectionLabel.innerHTML = "Error: Could not initialize agent. Check console for details.";
      }
      throw error;
    }
  }

  // Speech recognition integration
  let recognition;
  let recognizing = false;

  function initializeSpeechRecognition() {
    recognition = speechRecognitionUtils.initializeSpeechRecognition();
    if (recognition) {
      speechRecognitionUtils.configureSpeechRecognition(
        recognition,
        langSelect,
        reset,
        handleSpeechResult
      );
    }
  }

  function reset() {
    recognizing = false;
    speechButton.style.color = "";
    speechButton.innerHTML = "&#127908;";
    speakButton.removeAttribute("disabled");
  }

  function handleSpeechResult(event) {
    for (let i = event.resultIndex; i < event.results.length; ++i) {
      if (event.results[i].isFinal) {
        const transcript = event.results[i][0].transcript;
        speak(transcript);
      }
    }
  }

  function toggleStartStop() {
    if (!recognition) {
      initializeSpeechRecognition();
    }

    if (!recognition) {
      console.error('Speech recognition could not be initialized');
      return;
    }

    recognition.lang = langSelect.value;
    if (recognizing) {
      recognition.stop();
      reset();
    } else {
      recognition.start();
      recognizing = true;
      speechButton.style.color = "red";
      speechButton.innerHTML = "&#x23F9;";
      speakButton.setAttribute("disabled", true);
    }
  }

  // Event Listeners for Agent's built-in methods
  if (speakButton) speakButton.addEventListener('click', () => speak(textArea.value));
  if (reconnectButton) reconnectButton.addEventListener('click', () => reconnect());
  if (speechButton) speechButton.addEventListener('click', () => toggleStartStop());

  // Focus on input and button disabling when loading
  window.addEventListener('load', () => {
    if (textArea) {
      textArea.focus();
      // Update the Enter key press event to trigger speak
      textArea.addEventListener('keypress', (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          speak(textArea.value);
        }
      });
    }
    if (speakButton) speakButton.setAttribute("disabled", true);
    if (langSelect) langSelect.setAttribute("disabled", true);
    if (speechButton) speechButton.setAttribute("disabled", true);

    // Initialize the agent manager
    initializeAgentManager().then(() => {
      console.log("Agent manager initialized successfully");
      // Enable buttons after successful initialization
      if (speakButton) speakButton.removeAttribute("disabled");
      if (langSelect) langSelect.removeAttribute("disabled");
      if (speechButton) speechButton.removeAttribute("disabled");
      
      // Initialize speech recognition
      initializeSpeechRecognition();
    }).catch(error => {
      console.error("Failed to initialize agent manager:", error);
      if (connectionLabel) {
        connectionLabel.innerHTML = "Error: Could not initialize agent. Please check the console for details.";
      }
    });
  });

  // Event listener for language selection
  if (langSelect) {
    langSelect.addEventListener('change', () => {
      if (recognition) {
        recognition.lang = langSelect.value;
      }
    });
  }

  // Export functions that need to be globally accessible
  window.speak = speak;
  window.rate = rate;
  window.reconnect = reconnect;
  window.disconnect = disconnect;
  window.toggleStartStop = toggleStartStop;
});